import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { DomainConflict } from '../../types';

export interface DomainConflictModalData {
  conflicts: DomainConflict[];
  brandName: string;
}

@Component({
  selector: 'app-domain-conflict-modal',
  imports: [ButtonComponent],
  templateUrl: './domain-conflict-modal.component.html',
  styleUrl: './domain-conflict-modal.component.scss'
})
export class DomainConflictModalComponent {
  public data: DomainConflictModalData = inject(MAT_DIALOG_DATA);

  constructor(private dialogRef: MatDialogRef<DomainConflictModalComponent>) {}

  confirm(): void {
    this.dialogRef.close(true);
  }

  goBack(): void {
    this.dialogRef.close(false);
  }

  formatBrands(brands: { brandKey: string; name: string }[]): string {
    return brands.map(b => `${b.name} (${b.brandKey})`).join(', ');
  }
}
